export const SETTING_TYPE_SECTION = 1;
export const SETTING_TYPE_IMAGE = 2;
export const SETTING_TYPE_VIDEO = 3;


// WEBPACK FOOTER //
// ./src/containers/pages/settings/constants.js